<template>
  <div
    class="fill-height"
  >
    <v-row class="d-flex justify-center fill-height">
      <v-col
        cols="12"
      >
        <v-card
          class="mx-auto"
          max-width="1920"
        >
          <v-card-title>{{ $vuetify.lang.t('$vuetify.preferences') }}</v-card-title>
          <v-card-text>
            <v-form>
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                  sm="6"
                >
                  <v-select
                    v-model="editedItem.language"
                    :items="languages"
                    :label="$vuetify.lang.t('$vuetify.selectLanguage')"
                    prepend-icon="mdi-translate"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                  sm="6"
                >
                  <v-switch
                    v-model="editedItem.darkTheme"
                    color="primary"
                    :label="$vuetify.lang.t('$vuetify.darkTheme')"
                  />
                </v-col>
                <v-col
                  cols="12"
                  class="d-flex justify-center"
                >
                  <v-btn
                    color="primary"
                    @click="save"
                  >
                    {{ $vuetify.lang.t('$vuetify.save') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import lodash from 'lodash';
import objectPath from 'object-path';
import apiUtil from '../utils/ApiUtil';

export default {
  data: () => {
    return {
      editedItem: {
        language: 'en',
        darkTheme: false,
      },
      data: {},
    };
  },
  computed: {
    languages() {
      return [
        { text: this.$vuetify.lang.t('$vuetify.english'), value: 'en' },
        { text: this.$vuetify.lang.t('$vuetify.german'), value: 'de' },
      ];
    },
    intervals() {
      return [
        { text: this.$vuetify.lang.t('$vuetify.daily'), value: 'daily' },
        { text: this.$vuetify.lang.t('$vuetify.weekly'), value: 'weekly' },
        { text: this.$vuetify.lang.t('$vuetify.monthly'), value: 'monthly' },
      ];
    },
  },
  async created() {
    this.$store.dispatch('setGlobalLoading', true);
    await this.initialize();
    this.$store.dispatch('setGlobalLoading', false);
  },
  methods: {
    async initialize() {
      const result = await apiUtil.getAllPreferences();
      this.data = result;
      this.editedItem = lodash.assignIn(this.editedItem, objectPath.get(result, 'settings', {}));
    },
    async save() {
      const result = await apiUtil.savePreferences({ id: objectPath.get(this.data, 'id'), settings: this.editedItem });
      this.data = result;

      this.$store.dispatch('setUserTheme', this.editedItem.darkTheme);
      this.$vuetify.theme.dark = this.editedItem.darkTheme;
      this.$store.dispatch('setUserLang', this.editedItem.language);
      this.$vuetify.lang.current = this.editedItem.language;
    },
  },
};
</script>
